import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://tswlmunawmiqfdxokjwp.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRzd2xtdW5hd21pcWZkeG9randwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIzNjU1NTQsImV4cCI6MjA4Nzk0MTU1NH0.4BAR_umBIWQvzLL2WQaQiiSLLckuR2FG93-3fX4E0Yk';

export const supabase = createClient(supabaseUrl, supabaseKey);
